import React, { useState } from "react";
import { createFilterOptions } from "@mui/material/Autocomplete";
import { useEffect } from "react";
import { Autocomplete, Popper, styled } from "@mui/material";
import TextInput from "./TextInput";

const Select = ({
  options = [{ code: "", display_name: "" }],
  handleChange = () => {},
  selectedValue,
  label,
  error,
  readOnly,
  noSort,
  ...props
}) => {
  const [value, setValue] = useState(null);
  const [inputValue, setInputValue] = useState("");
  const onChange = (e, value) => {
    setValue(value);
    handleChange(value.code);
  };
  useEffect(() => {
    if (selectedValue) {
      const x = options.find(item => item.code === selectedValue);
      setValue(x || null);
      setInputValue(x?.display_name || "");
    } else {
      setValue(null);
      setInputValue("");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedValue]);
  const onInputChange = (e, newValue) => {
    setInputValue(newValue);
  };

  const filterOptions = createFilterOptions({
    matchFrom: "start",
    stringify: option => option.display_name,
  });

  return (
    <>
      {readOnly ? (
        <TextInput
          value={inputValue}
          label={label}
          inputProps={{ readOnly: true }}
        />
      ) : (
        <StyledAutoComplete
          filterOptions={filterOptions || ""}
          options={
            noSort
              ? options
              : options?.sort((a, b) =>
                  a?.display_name
                    ?.toLowerCase()
                    ?.localeCompare(b?.display_name?.toLowerCase()),
                )
          }
          disablePortal
          disableClearable
          blurOnSelect
          onChange={onChange}
          onInputChange={onInputChange}
          getOptionLabel={item => item.display_name || ""}
          value={value}
          clearOnBlur
          PopperComponent={({ style, ...props }) => (
            <Popper {...props} style={{ ...style, height: 0 }} />
          )}
          fullWidth={props.fullWidth}
          ListboxProps={{ style: { maxHeight: "50vh" } }}
          inputValue={inputValue || ""}
          isOptionEqualToValue={(item, value) => item.code === value.code}
          renderInput={params => (
            <TextInput
              {...params}
              label={label}
              error={error}
              inputProps={{
                ...params.inputProps,
                readOnly: props?.noSearch,
              }}
            />
          )}
        />
      )}
    </>
  );
};
const StyledAutoComplete = styled(Autocomplete)({
  "& .MuiOutlinedInput-root": {
    padding: "6px 8px !important",
  },
});
export default Select;
